import Component from '../Component';
import Routes from '../../routes';
import tippy from 'tippy.js';

export default class ToolTip extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.start();
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.App.Events.subscribe('tooltip.refresh', () => {
      this.start();
    });
  }

  start() {

    tippy('[title]:not(.is-hidden):not(.is-ip):not(.sidebar .icon):not(.map-marker)', {
      delay: [400, 0],
      arrow: true,
      arrowType: 'round',
      content: (reference) => {
        let title = reference.getAttribute('title');
        reference.removeAttribute('title');
        return title;
      }
    });

    tippy('.sidebar .icon[title]', {
      delay: [0, 0],
      arrow: true,
      arrowType: 'round',
      animateFill: false,
      animation: 'shift-away',
      placement: 'right',
      distance: 26,
      boundary: 'window',
      content: (reference) => {
        let title = reference.getAttribute('title');
        reference.removeAttribute('title');
        return title;
      }
    });

    tippy('.map-marker[title]', {
      delay: [0, 0],
      arrow: true,
      arrowType: 'round',
      content: (reference) => {
        let title = reference.getAttribute('title');
        reference.removeAttribute('title');
        return title;
      }
    });

    tippy('.is-ip', {
      delay: [0, 0],
      arrow: true,
      arrowType: 'round',
      onHidden: (instance) => {
        instance.setContent(
          this.App.Language.get('_.loading')
        )
      },
      onShow: (instance) => {

        if (instance.state.ajax === undefined) {

          instance.setContent(
            this.App.Language.get('_.loading')
          );

          instance.state.ajax = {
            isFetching: false,
            canFetch: true
          }
        }

        // Now we will avoid initiating a new request unless the old one
        // finished (`isFetching`).
        // We also only want to initiate a request if the tooltip has been
        // reset back to Loading... (`canFetch`).
        if (instance.state.ajax.isFetching || !instance.state.ajax.canFetch) {
          return;
        }

        // instance.state.ajax.isFetching = false
        return this.App.API.get(
          Routes.API.DEV.GEOIP + '/' + instance.reference.getAttribute('data-ip')
        ).then((response) => {

          if (response.status === 200 && response.data.data.default === false) {
            let ip = response.data.data;
            instance.setContent(ip.city +', '+ ip.country);
          } else {
            instance.setContent(
              this.App.Language.get('_.no_data')
            );
          }

        }).catch((error) => {
          return instance.setContent(
            this.App.Language.get('errors.internal_error')
          );
        }).finally(() => {
          instance.state.ajax.isFetching = false;
        });
      }

    });

  }

}